export default __webpack_public_path__ + "static/media/youtube-thumb.443b8827.jpg";